import type {
  Integer,
  IntegerInputProps
} from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { InputInteger } from './InputInteger'

export function IntegerInput(props: IntegerInputProps) {
  const { inputId, onBlur, onChange, onFocus, value } = props

  function handleChange(newValue: string) {
    const parsed = newValue === '' ? null : Number.parseInt(newValue, 10)
    onChange(parsed as Integer)
  }

  // Convert `number | null` to `string | undefined`, gracefully handling NaN and infinity
  const inputValue =
    value === null || !Number.isFinite(value) ? undefined : value.toString()

  return (
    <InputFieldset {...props}>
      <InputInteger
        id={inputId}
        name={inputId}
        value={inputValue}
        onChange={handleChange}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    </InputFieldset>
  )
}
